import { render, staticRenderFns } from "./PlotConnectsForm.vue?vue&type=template&id=2adc6d6e&"
import script from "./PlotConnectsForm.vue?vue&type=script&lang=js&"
export * from "./PlotConnectsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports